import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface Metrics {
  [key: string]: { count: number; avgMs: number; errors: number };
}

export const observabilityApi = createApi({
  reducerPath: 'observabilityApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMetrics: builder.query<Metrics, void>({
      query: () => ({ url: '/observability/metrics' })
    }),
    getErrors: builder.query<string, void>({
      query: () => ({ url: '/observability/errors', responseHandler: 'text' })
    }),
    viewAs: builder.mutation<{ token: string }, string>({
      query: (userId) => ({
        url: `/observability/view-as/${userId}`,
        method: 'POST'
      })
    })
  })
});

export const { useGetMetricsQuery, useGetErrorsQuery, useViewAsMutation } = observabilityApi;
